module.exports = __webpack_public_path__ + "static/media/save.4ce5a56e.svg";